import { compose } from "recompose";
import { connect } from "react-redux";
import { firestoreConnect, isLoaded, isEmpty } from "react-redux-firebase";
import DashboardIndex from "components/Dashboard/Dashboard";

const mapStateToProps = state => {
  const { firestore, firebase } = state;

  const customers = firestore.data.customers;
  const equipments = firestore.data.equipments;
  const regions = firestore.data.regions;
  const notifications = firestore.data.notifications;
  const schedulers = firestore.data.schedulers;

  const customersCount = (customers && Object.keys(customers).length) || 0;
  const equipmentsCount = (equipments && Object.keys(equipments).length) || 0;
  const regionsCount = (regions && Object.keys(regions).length) || 0;
  const notificationsCount =
    (notifications && Object.keys(notifications).length) || 0;
  const schedulersCount =
    (schedulers && Object.keys(schedulers).length) || 0;

  const auth = firebase.auth;

  const isLoading = !isLoaded(regions);
  const isDataEmpty = isEmpty(regions);

  return {
    isLoading: isLoading,
    isEmpty: isDataEmpty,
    customers: customersCount,
    equipments: equipmentsCount,
    regions: regionsCount,
    notifications: notificationsCount,
    schedulers: schedulersCount,
    auth: auth,
  };
};

export default compose(
  firestoreConnect([
    { collection: "customers" },
    { collection: "equipments" },
    { collection: "regions" },
    { collection: "notifications" },
    { collection: "schedulers" },
  ]),
  connect(mapStateToProps)
)(DashboardIndex);
